import { useAppSelector } from '@/features/hooks';

/**
 * Initialize auth without a network request.
 *
 * The browser may have a valid httpOnly refresh cookie while Cloud Run is
 * scaled to zero. The last non-secret user profile is restored synchronously;
 * the first intentional API request performs normal server validation/refresh.
 */
export const useAuthInit = () => {
  const { isInitialized } = useAppSelector((state) => state.auth);
  return { isInitialized };
};
